// https://shopify.dev/docs/api/ajax/reference/cart#bundled-section-rendering
import DynamicSectionElement from '@/js/dynamic-section-element';
import {
  onCartUpdate,
  updateItemQuantityRequest
} from '@/js/utils/cart-utilities.js';

class LineItem extends DynamicSectionElement {
  constructor() {
    super();
    this.keys = JSON.parse(this.dataset.keys);
    this.flyoutCart = document.querySelector('flyout-cart');
    this.quickOrderList = document.querySelector('quick-order-list');

    this.sectionsList = [
      this.flyoutCart.dataset.sectionId,
      ...(this.quickOrderList ? [this.quickOrderList.dataset.sectionId] : [])
    ];
  }

  connectedCallback() {
    this.setEventListeners();
  }

  /**
   * Set event listeners for the line item
   * @returns {void}
   */
  setEventListeners() {
    this.removeButton = this.querySelector('[data-remove]');
    if (!this.removeButton) return;

    // Register event listeners
    this.removeButton.addEventListener('click', () => this.removeItem());
    this.addEventListener('pxl:quantityChange', event => {
      this.updateQuantity(event);
    });
  }

  afterSectionRender() {
    this.setEventListeners();
  }

  /**
   * Update the quantity of the line item
   * @param {event} event
   * @returns {void}
   */

  async updateQuantity(event) {
    let quantity = 0;
    let updates = {};

    if (event) {
      quantity = Number.parseInt(event.detail.quantity);
    }

    for (const key of this.keys) {
      updates[key] = quantity;
    }

    try {
      const response = await updateItemQuantityRequest(
        updates,
        this.sectionsList
      );

      if (!response.ok) {
        // eslint-disable-next-line no-console
        console.error('Error with POST request');
        return;
      }

      let scrollPosition = document.querySelector('[data-items]')?.scrollTop;

      if (scrollPosition == undefined) {
        return;
      }

      response.json().then(cartResponseJson => {
        onCartUpdate(cartResponseJson);
        document.querySelector('[data-items]')?.scrollTo(0, scrollPosition);

        if (cartResponseJson.item_count == 0) {
          this.flyoutCart.closeFlyoutCart();
        } else {
          document.querySelector('[data-items]').scrollTo(0, scrollPosition);
        }
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error with PUT request', error);
    }
  }

  /**
   * Remove the line item from the cart
   * @returns {void}
   */
  removeItem() {
    // add the class remove for animation affect
    this.classList.add('remove');
    this.updateQuantity();
  }
}

customElements.get('line-item') || customElements.define('line-item', LineItem);
